/** Returns a copy of errors with one field cleared (for onChange handlers). */
export function clearFieldError<T extends Record<string, string>>(errors: T, field: keyof T): T {
  if (!errors[field]) {
    return errors;
  }
  const next = { ...errors };
  delete next[field];
  return next;
}

/** Label class when a field has a validation error. */
export function fieldLabelClass(hasError: boolean): string {
  return hasError ? "text-destructive" : "";
}
